// F-64: Bullets / Numbering over lines separated by SOFT line breaks give one item per line.
// Text pasted from Word / Google Docs / web pages / our own report editor often separates its lines with <br> (Shift+Enter),
// which lands as hard breaks inside ONE paragraph, and a list wraps paragraphs, so the whole block became one bullet.
// Before a list is put ON, the paragraphs the selection touches are split at their hard breaks, in the same transaction
// (one undo step restores the original). Runs of breaks (an empty line) and breaks at a paragraph's start / end are only
// removed, never turned into empty items. Turning a list OFF is unchanged. Shared by the notes and report editors (both
// toolbars + Mod-Shift-8 / Mod-Shift-7); each bundle carries its own copy.

// Split the selected paragraphs at their hard breaks (in `tr`). → the number of breaks handled.
export function splitSoftLines(tr) {
  const { from, to } = tr.selection;
  const $f = tr.doc.resolve(from), $t = tr.doc.resolve(to);
  const start = $f.parent.isTextblock ? $f.start() : from, end = $t.parent.isTextblock ? $t.end() : to;
  const brs = [];
  tr.doc.nodesBetween(start, end, (node, pos, parent, index) => {
    if (node.type.name !== 'hardBreak' || !parent || parent.type.name !== 'paragraph') return;
    const next = index + 1 < parent.childCount ? parent.child(index + 1) : null;
    const edge = index === 0 || !next || next.type.name === 'hardBreak';
    brs.push({ pos, edge });
  });
  for (let i = brs.length - 1; i >= 0; i--) {
    const { pos, edge } = brs[i];
    tr.delete(pos, pos + 1);
    if (!edge) tr.split(pos);
  }
  return brs.length;
}

// The list command both toolbars and the shortcuts run. `chain` = editor.chain().focus(); `type` = 'bulletList' | 'orderedList'.
export function toggleListBySoftLines(chain, editor, type) {
  if (!editor.isActive(type)) chain = chain.command(({ tr }) => { splitSoftLines(tr); return true; });
  return type === 'orderedList' ? chain.toggleOrderedList() : chain.toggleBulletList();
}

// Mod-Shift-8 / Mod-Shift-7 run the same command (ahead of the list extensions' own shortcuts).
export function softLineListShortcuts(Extension) {
  return Extension.create({
    name: 'hudSoftLineLists',
    priority: 1000,
    addKeyboardShortcuts() {
      return {
        'Mod-Shift-8': () => toggleListBySoftLines(this.editor.chain().focus(), this.editor, 'bulletList').run(),
        'Mod-Shift-7': () => toggleListBySoftLines(this.editor.chain().focus(), this.editor, 'orderedList').run(),
      };
    },
  });
}
